import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  SearchApiResultsConstants as SearchResultsConstants,
  FILTER_IDS,
  ZERO_INDEX_EQUALIZER,
} from '@src/js/constants.js';
import { LoadingBox, Pagination, SearchFilterList } from '@src/components/core/core-component-imports.js';
import SpecialtySearchFilter from './specialty-search-filter.jsx';
import OnlineSchedulingSearchFilter from './online-scheduling-search-filter.jsx';
import useProviderSearch from '@src/hooks/use-provider-search.jsx';
import ProviderResultsCards from './provider-results-cards.jsx';
import FindProvidersMap from '@js/find-providers-map.es6.js';
import FindAProviderResultsContentType from '@js/content-types/find-a-provider-results-content-type.es6.js';

const ProviderResults = () => {
  const [searchParams] = useSearchParams();
  const search = searchParams.get(FILTER_IDS.SEARCH);
  const location = searchParams.get(FILTER_IDS.LOCATION);
  const specialty = searchParams.get(FILTER_IDS.SPECIALTY);
  const onlineSchedulingType = searchParams.get(FILTER_IDS.ONLINE_SCHEDULING_TYPE);
  const pageNum = searchParams.get(FILTER_IDS.PAGE) - ZERO_INDEX_EQUALIZER;

  const findAProviderResults = new FindAProviderResultsContentType();
  const countLabel = findAProviderResults.countLabel.item.$(0).text();
  const pageLabel = findAProviderResults.pageLabel.item.$(0).text();
  const ofLabel = findAProviderResults.ofLabel.item.$(0).text();

  const { loading, error, response } = useProviderSearch({
    search,
    location,
    specialty,
    onlineSchedulingType,
    pageNum,
  });

  if (loading || error || !response) {
    return (
      <LoadingBox />
    );
  }

  const providers = response.rows;
  const resultsCount = response.pager[SearchResultsConstants.TOTAL_ITEMS];
  const totalPages = response.pager[SearchResultsConstants.TOTAL_PAGES];

  new FindProvidersMap(providers);

  return (
    <div className='providers-results--wrapper'>
      <SearchFilterList
        searchFilters={[
          SpecialtySearchFilter,
          OnlineSchedulingSearchFilter,
        ]}
      />
      <p className='results-count'>{resultsCount} {countLabel}</p>
      <ProviderResultsCards providers={providers} />
      <div className='pagination--container'>
        <Pagination
          pageLabel={pageLabel}
          ofLabel={ofLabel}
          pageNum={pageNum}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default ProviderResults;
